import { create } from "zustand";

export type ManifestStatus = "idle" | "rendering" | "ready" | "error";

type ManifestStoreState = {
	status: ManifestStatus;
	error: string | null;
	previewUrl: string | null;
	blob: Blob | null;
	renderNonce: number;
	setRendering: () => void;
	setReady: (blob: Blob) => void;
	setError: (message: string) => void;
	requestRender: () => void;
	reset: () => void;
};

/**
 * Zustand store for collection manifest image generation state.
 */
export const useManifestStore = create<ManifestStoreState>((set, get) => ({
	status: "idle",
	error: null,
	previewUrl: null,
	blob: null,
	renderNonce: 0,
	setRendering: () => {
		set({ status: "rendering", error: null });
	},
	setReady: (nextBlob) => {
		const previousUrl = get().previewUrl;
		if (previousUrl) {
			URL.revokeObjectURL(previousUrl);
		}
		const nextUrl = URL.createObjectURL(nextBlob);
		set({
			status: "ready",
			error: null,
			blob: nextBlob,
			previewUrl: nextUrl,
		});
	},
	setError: (message) => {
		set({ status: "error", error: message });
	},
	requestRender: () => {
		set((state) => ({
			status: "rendering",
			error: null,
			renderNonce: state.renderNonce + 1,
		}));
	},
	reset: () => {
		const previousUrl = get().previewUrl;
		if (previousUrl) {
			URL.revokeObjectURL(previousUrl);
		}
		set({
			status: "idle",
			error: null,
			previewUrl: null,
			blob: null,
			renderNonce: 0,
		});
	},
}));
